export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			value: '',
			is_title: true,
		},
		{
			text: 'Descripcion',
			key: 'description',
			type: 'textarea',
		},
	],
	singular_model_name_spanish: 'Deposito',
	plural_model_name_spanish: 'Depositos',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
}